import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface AppState {
  isOnline: boolean;
  setIsOnline: (newState: boolean) => void;
  indicator: boolean;
  showIndicator: () => void;
  hideIndicator: () => void;
   translateObject: {
    toText: string;
    imageUrl?: string;
    isHtml?: boolean;
    fromText?: string;
  };
  setTranslateObject: (newState: {
    toText: string;
    imageUrl?: string;
    isHtml?: boolean;
    fromText?: string;
  }) => void;
  showTranslatePopover: boolean;
  setShowTranslatePopover: (newState: boolean) => void;
  showActivityIndicator: boolean;
  setShowActivityIndicator: (newState: boolean) => void;
}

const useAppStore = create<AppState>()(
  devtools((set) => ({
    isOnline: false,
    setIsOnline: newState => set(state => ({isOnline: newState})),
    indicator: false,
    showIndicator: () => set(state => ({indicator: true})),
    hideIndicator: () => set(state => ({indicator: false})),
    translateObject: {
      toText: '',
      imageUrl: undefined,
      isHtml: false,
      fromText: undefined,
    },
    setTranslateObject: newState => set(state => ({translateObject: newState})),
    showTranslatePopover: false,
    setShowTranslatePopover: (newState) =>
      set((state) => ({ showTranslatePopover: newState })),
    showActivityIndicator: false,
    setShowActivityIndicator: (newState) =>
      set((state) => ({ showActivityIndicator: newState })),
  }))
);

export default useAppStore;
